/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Promo_Movement_Qty_HintInputs */



/**
* | output |
* | --- |
* | "Use a negative quantity to record a correction." |
*
* @param {Promo_Movement_Qty_HintInputs} inputs
* @param {{ locale?: "en" | "fr" | "es" | "pt" | "it" }} options
* @returns {LocalizedString}
*/
export const promo_movement_qty_hint = /** @type {((inputs?: Promo_Movement_Qty_HintInputs, options?: { locale?: "en" | "fr" | "es" | "pt" | "it" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Promo_Movement_Qty_HintInputs, { locale?: "en" | "fr" | "es" | "pt" | "it" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Utilisez une quantité négative pour enregistrer une correction.")
	if (locale === "es") return /** @type {LocalizedString} */ ("Use una cantidad negativa para registrar una corrección.")
	if (locale === "pt") return /** @type {LocalizedString} */ ("Use uma quantidade negativa para registrar uma correção.")
	if (locale === "it") return /** @type {LocalizedString} */ ("Usa una quantità negativa per registrare una correzione.")
	return /** @type {LocalizedString} */ ("Use a negative quantity to record a correction.")
});